import { render } from "./ManageClockInLocations.vue?vue&type=template&id=c01d4282"
import script from "./ManageClockInLocations.vue?vue&type=script&lang=js"
export * from "./ManageClockInLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__